<dgx-components-accordion [panels]="panels">
  <ng-template
    #accordionPanelHeaderTemplate
    let-expanded="expanded"
    let-panel="panel"
  >
    <span
      [ngClass]="{
        'protection-details-accordion-panel-header--subtext':
          panels[0] === panel
      }"
      class="protection-details-accordion-panel-header"
    >
      <dgx-components-icon
        [name]="'chevron-down'"
        [ngClass]="{
          'protection-details-accordion-panel--expanded': expanded
        }"
        [size]="!isDesktop ? 'sm' : 'lg'"
        class="protection-details-accordion-panel-header__icon"
      />

      <p class="protection-details-accordion-panel-header__title">
        {{ panel.title }}
      </p>

      <div
        [ngClass]="{
          'protection-details-accordion-panel-header__comparison-icons--subtext':
            panels[0] === panel
        }"
        class="protection-details-accordion-panel-header__comparison-icons"
      ></div>
    </span>
  </ng-template>

  <ng-template
    #accordionPanelContentTemplate
    let-expanded="expanded"
    let-panel="panel"
  >
    <div class="protection-details-accordion-panel-body">
      <dgx-components-rich-text [content]="panel.body" />
    </div>
  </ng-template>
</dgx-components-accordion>
